import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import Styles from "./index.module.scss";

ChartJS.register(ArcElement, Tooltip, Legend);

const PieChart = ({ chartData }) => (
  <div className="row">
    {[
      [chartData.revenueBreakDownOrderData, ["#938497", "#CB998D", "#E4E0E5", "#c6c6c6"]],
      [chartData.revenueBreakDownOrderCount, ["#E4E0E5", "#CB998D", "#938497"]],
    ].map(([rows, backgroundColor], i) => (
      <div className="col" key={i}>
        <Doughnut
          data={{
            labels: rows.map((r) => r.title),
            datasets: [
              {
                data: rows.map((r) => r.per),
                backgroundColor,
                borderColor: ["#CB998D"],
                borderWidth: 0.1,
                hoverOffset: 4,
              },
            ],
          }}
          height={110}
          width={110}
          style={{ marginLeft: "50px" }}
        />
        <div className={`d-flex mt-4 ${Styles.PieChartList}`}>
          <ul>
            {rows.map((r) => (
              <li key={r.title}>
                {r.title} - <span>${r.status}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    ))}
  </div>
);
export default PieChart;
